import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { FileDeterminant } from "../../../../../models/file-determinant";
import { BooleanDeterminant } from "../../../../../models/boolean-determinant";
import { BotDeterminant } from "../../../../../models/bot-determinant";
import { ButtonDeterminant } from "../../../../../models/button-determinant";
import { ClassificationDeterminant } from "../../../../../models/classification-determinant";
import { FileUploadDeterminant } from "../../../../../models/file-upload-determinant";
import { GridComponentDeterminant } from "../../../../../models/grid-component-determinant";
import { CollectionPlaceDeterminant } from "../../../../../models/collection_place-determinant";
import { DateDeterminant } from "../../../../../models/date-determinant";
import { Determinant } from "../../../../../models/determinant";
import { GridDeterminant } from "../../../../../models/grid-determinant";
import { FieldType } from "../../../../../models/field-type";
import { MoneyDeterminant } from "../../../../../models/money-determinant";
import { NumericDeterminant } from "../../../../../models/numeric-determinant";
import { RadioDeterminant } from "../../../../../models/radio-determinant";
import { Registration } from "../../../../../models/registration";
import { RegistrationDeterminant } from "../../../../../models/registration-determinant";
import { RegistrationServiceLocation } from "../../../../../models/registration-service-location";
import { SelectBoxesDeterminant } from "../../../../../models/selectboxes-determinant";
import { SelectDeterminant } from "../../../../../models/select-determinant";
import { SelectOperatorType } from "../../../../../models/select-operator";
import { SubCatalogDeterminant } from "../../../../../models/sub-catalog-determinant";
import { TextDeterminant } from "../../../../../models/text-determinant";
import { RegistrationServiceLocationControllerService } from "../../../../../services/location-controller/registration-service-location-controller.service";
import { DeterminantControllerService } from "../../../../../services/registration-controller/determinant-controller.service";
import { RegistrationControllerService } from "../../../../../services/registration-controller/registration-controller.service";
import { Store } from "../../../../../services/store.service";
import { TranslatedBaseError } from "../../../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";
import { DeterminantType } from "src/app/models/determinant-type";
import { FormControllerService } from "src/app/services/form-controller/form-controller.service";
import moment from "moment";
import * as _ from "lodash";

@Component({
  selector: "determinant-new",
  templateUrl: "./determinant-new.component.html",
  styles: [],
  providers: [
    FormControllerService,
    DeterminantControllerService,
    ToastrService,
  ],
})
export class DeterminantNewComponent extends TranslatedBaseError implements OnInit {

  @Input() public serviceId: string;
  @Input() public determinant: any;
  @Input() public existingDeterminants: Determinant[] = [];
  @Output() public formSubmit = new EventEmitter();
  @Output() public editCancel = new EventEmitter();
  @Input() public dragIcons: boolean = false;
  @Input() public stickyScrolling: boolean = false;
  @Input() public forcePadding: boolean = false;
  @Input() public isOnSubLayer: boolean = false;
  @Input() public hideHeader: boolean = false;
  @Input() public noContentPadding: boolean = false;
  @Input() public hideButtons: boolean = false;
  @Input() public detElementId: string = null;
  @Input() public isEmbedded: boolean = false;
  @Input() public isClosed: boolean = true;
  public fields: any[] = [];
  public id: string;
  public name: string;
  public registration: Registration;
  public registrations: Registration[] = [];
  public registrationServiceLocations: RegistrationServiceLocation[] = [];
  public registrationLocation: RegistrationServiceLocation;
  public determinantType = DeterminantType.FORMFIELD.toString();
  public type = "";
  public booleanValue: boolean = true;
  public numericValue: number;
  public isLoading: boolean = false;
  public windowParent: any;
  public thisElement: any;
  public loading: boolean = true;
  public showUsages: boolean = false;
  public showDuplicates: boolean = false;

  constructor(
    private formControllerService: FormControllerService,
    private determinantService: DeterminantControllerService,
    private registrationController: RegistrationControllerService,
    private registrationServiceLocationControllerService: RegistrationServiceLocationControllerService,
    public store: Store,
    public toastr: ToastrService,
    public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.loading = true;
    console.log(this.determinant, this.detElementId, this.isOnSubLayer);

    // Load existing determinants if not provided
    if (!this.existingDeterminants || this.existingDeterminants.length === 0) {
      this.loadExistingDeterminants();
    }

    if (this.detElementId && this.isOnSubLayer) {
      const windowParent = window.parent.document.querySelector(".component-settings").querySelector(".formio-dialog-content > div > div");
      if (windowParent) {
        // const windowParent = window.parent.document.querySelector(".component-settings").querySelector(".formio-dialog-content > div > div");
        windowParent.querySelector(":scope > .row:nth-child(1)").classList.add("d-none");
        windowParent.querySelector(":scope > .row:nth-child(2)").classList.add("p-0");
        windowParent.querySelector(":scope > .row:nth-child(2)").querySelector("#myBuilder").classList.add("m-0");
        windowParent.querySelector(":scope > .row:nth-child(2)").querySelector(".tab-pane.active").classList.add("p-0", "m-0");
        windowParent.querySelector("#element1").querySelector(":scope > .formio-component-tabs").querySelector(":scope > div > .nav-tabs").classList.add("d-none");
        window.parent?.document?.querySelector(".component-settings").querySelector(".formio-dialog-close").classList.add("d-none");

        const copyValueFrom = windowParent.querySelector(":scope > .row:nth-child(2)").querySelector("#copyValueFromTab").querySelector(":first-child");
        if (copyValueFrom) {
          copyValueFrom.classList.add("d-none");
          windowParent.classList.add("p-0", "m-0");
          windowParent.querySelectorAll(".page-iframe")?.forEach((iframe) => iframe.classList.add("full-drawer-content"));
        }
        // windowParent.querySelector(":scope > .row:last-child").classList.add("d-none");
      }
    }
    if (this.serviceId) {
      this.formControllerService.getFieldsWithSchemas(this.serviceId).subscribe((data) => {
        this.fields = data.filter((d) => {
          return d.key && d.key.indexOf("_child_") === -1 && d.type !== "catalog" && d.type !== "panel" && d.type !== "datagrid" && d.type !== "editgrid";
        });

        this.loadRegistrationList();
      });
    }
  }

  public initDeterminant() {
    if (this.determinant != null && this.determinant.type != null && this.determinant.name != null) {
      this.id = this.determinant.id;
      this.name = this.determinant.name;
      this.determinantType = this.determinant.determinantType;
      this.type = this.determinant.type;
      if (this.determinantType === "REGISTRATION") {
        this.booleanValue = this.determinant.selected;
        this.registration = this.registrations.find(
          (x) => x.id === this.determinant.registrationId,
        );
      } else if (this.determinantType === "COLLECTION_PLACE") {
        this.booleanValue = this.determinant.selected;
        this.registrationLocation = this.registrationServiceLocations.find(
          (x) => x.id === this.determinant.registrationServiceLocationId,
        );
      }
    }
    this.loading = false;
  }

  public loadRegistrationList() {
    this.registrationController.getRegistrationsList(this.serviceId).subscribe(
      (data) => {
        this.registrations = data;
        this.loadRegistrationLocations();
      },
      (error) => { this.showErrorMessage(error); this.isLoading = false; },
    );
  }

  public loadRegistrationLocations() {
    this.registrationServiceLocationControllerService
      .getRegistrationServiceLocationsByService(this.serviceId)
      .subscribe(
        (data) => {
          this.registrationServiceLocations = data;
          this.initDeterminant();
        },
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
      );
  }

  public determinantTypeChanged(determinantType: string) {
    this.type = undefined;
    if (determinantType === "BOT") {
      this.determinant = new BotDeterminant();
    } else if (determinantType === "REGISTRATION") {
      this.determinant = new RegistrationDeterminant();
      this.determinant.selected = true;
      this.booleanValue = true;
    } else if (determinantType === "COLLECTION_PLACE") {
      this.determinant = new CollectionPlaceDeterminant();
      this.determinant.selected = true;
      this.booleanValue = true;
    } else if (determinantType === DeterminantType.FORMFIELD.toString()) {
      this.determinant = new Determinant();
    } else {
      // TODO init other determinant type
    }
  }

  public selectRegistration(registration: Registration) {
    // :( does not update field after select is changed without timeout
    setTimeout(() => {
      this.registration = registration;
      Store.callUglyAngularRedraw();
    }, 100);
  }

  public selectRegistrationLocation(
    registrationServiceLocation: RegistrationServiceLocation,
  ) {
    setTimeout(() => {
      this.registrationLocation = registrationServiceLocation;
      Store.callUglyAngularRedraw();
    }, 100);
  }

  /**
   * Loads existing determinants from the service if not provided via input.
   * This is needed for components that don't have direct access to the determinants list.
   * Also automatically checks for duplicates in the current determinant being edited.
   */
  private loadExistingDeterminants(): void {
    if (this.serviceId) {
      this.determinantService.getAllDeterminants(this.serviceId, true).subscribe(
        (determinants) => {
          this.existingDeterminants = determinants || [];
          // Check for duplicates if editing an existing determinant
          if (this.determinant && this.determinant.id) {
            this.checkAndMarkDuplicates();
          }
        },
        (error) => {
          console.warn("Error loading existing determinants for duplicate check", error);
          this.existingDeterminants = [];
        },
      );
    }
  }

  /**
   * Checks if the current determinant has duplicates and marks it accordingly.
   * This populates the isDuplicate flag and duplicateNames array.
   */
  private checkAndMarkDuplicates(): void {
    if (!this.determinant || !this.existingDeterminants || this.existingDeterminants.length === 0) {
      return;
    }

    const duplicates = this.findDuplicateDeterminants(this.determinant, this.determinant.id);
    this.determinant.isDuplicate = duplicates.length > 0;
    this.determinant.duplicateNames = duplicates.map((d) => d.name);
  }

  public booleanValueChanged(booleanValue: any) {
    if (this.determinant.determinantType === "BOT") {
      this.determinant.valid = booleanValue;
    } else if (this.determinant.determinantType === "REGISTRATION") {
      this.determinant.selected = booleanValue;
    } else if (this.determinant.determinantType === "COLLECTION_PLACE") {
      this.determinant.selected = booleanValue;
    }
  }

  public formFieldDeterminantChanged(determinant: Determinant) {
    console.log("--- formFieldDeterminantChanged", determinant);
    if (determinant) {
      this.determinant = determinant;
    }
  }

  public save() {
    if (!this.isLoading) {
      this.isLoading = true;
      // console.log(this.determinant, this.name, this.determinantType);
      this.determinant.name = this.name;
      // TO PUT BACK ONCE FIXED: Check for duplicates before creating new determinant
      /*
      if (this.determinant.id === undefined && this.isDuplicateDeterminant(this.determinant)) {
        this.isLoading = false;
        this.showErrorMessage("A determinant with the same configuration already exists!");
        return;
      }
      */
      // Check for event-based determinants by type
      if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.BUTTON) {
        if (this.determinant.id === undefined) {
          this.createButtonDeterminant(this.serviceId, this.determinant as ButtonDeterminant);
        } else {
          this.saveButtonDeterminant(this.serviceId, this.determinant as ButtonDeterminant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.GRID && (this.determinant as any).gridEventName !== undefined) {
        // GridComponentDeterminant (grid with events like editGridSelectRow)
        if (this.determinant.id === undefined) {
          this.createGridComponentDeterminant(this.serviceId, this.determinant as GridComponentDeterminant);
        } else {
          this.saveGridComponentDeterminant(this.serviceId, this.determinant as GridComponentDeterminant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.FILE && (this.determinant as any).fileUploadEventName !== undefined) {
        // FileUploadDeterminant (file upload with events)
        if (this.determinant.id === undefined) {
          this.createFileUploadDeterminant(this.serviceId, this.determinant as FileUploadDeterminant);
        } else {
          this.saveFileUploadDeterminant(this.serviceId, this.determinant as FileUploadDeterminant);
        }
      } else if (this.determinantType === "BOT") {
        this.determinant.name = this.name;
        if (this.determinant.id === undefined) {
          this.createBotDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveBotDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinantType === "REGISTRATION") {
        this.determinant.name = this.name;
        this.determinant.registrationId = this.registration
          ? this.registration.id
          : undefined;
        this.determinant.selected = this.booleanValue;
        if (this.determinant.id === undefined) {
          this.createRegistrationDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveRegistrationDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinantType === "COLLECTION_PLACE") {
        this.determinant.name = this.name;
        this.determinant.registrationServiceLocationId = this.registrationLocation
          ? this.registrationLocation.id
          : undefined;
        this.determinant.selected = this.booleanValue;
        if (this.determinant.id === undefined) {
          this.createCollectionPlaceDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveCollectionPlaceDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.BOOLEAN) {
        if (this.determinant.id === undefined) {
          this.createBooleanDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveBooleanDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.NUMERIC) {
        if (this.determinant.id === undefined) {
          this.createNumericDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveNumericDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.MONEY) {
        if (this.determinant.id === undefined) {
          this.createMoneyDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveMoneyDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && (this.determinant.type.toUpperCase() === FieldType.TEXT || this.determinant.type.toUpperCase() === FieldType.TEXTAREA)) {
        if (this.determinant.id === undefined) {
          this.createTextDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveTextDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && (this.determinant.type.toUpperCase() === FieldType.FILE)) {
        if (this.determinant.id === undefined) {
          this.createFileDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveFileDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.HIDDEN) {
        if (this.determinant.id === undefined) {
          this.createTextDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveTextDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.RADIO) {
        if (this.determinant.id === undefined) {
          this.createRadioDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveRadioDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.SELECTION) {
        if (this.determinant.id === undefined) {
          this.createSelectDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveSelectDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.SELECTBOXES) {
        if (this.determinant.id === undefined) {
          this.createSelectBoxesDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveSelectBoxesDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.DATE) {
        if (this.determinant.id === undefined) {
          this.createDateDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveDateDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && (this.determinant.type.toUpperCase() === FieldType.GROUPING) && (this.determinant.classificationOperator !== SelectOperatorType.EQUAL && this.determinant.classificationOperator !== SelectOperatorType.NOT_EQUAL)) {
        if (this.determinant.id === undefined) {
          this.createClassificationDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveClassificationDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && (this.determinant.type.toUpperCase() === FieldType.CLASSIFICATION) || (this.determinant.type.toUpperCase() === FieldType.GROUPING && (this.determinant.classificationOperator === SelectOperatorType.EQUAL || (this.determinant.classificationOperator === SelectOperatorType.NOT_EQUAL)))) {
        if (this.determinant.id === undefined) {
          this.createClassificationDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveClassificationDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.SUB_CATALOG) {
        if (this.determinant.id === undefined) {
          this.createSubCatalogDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveSubCatalogDeterminant(this.serviceId, this.determinant);
        }
      } else if (this.determinant && this.determinant.type && this.determinant.type.toUpperCase() === FieldType.GRID) {
        if (this.determinant.id === undefined) {
          this.createGridDeterminant(this.serviceId, this.determinant);
        } else {
          this.saveGridDeterminant(this.serviceId, this.determinant);
        }
      }
    }
  }

  public cancel() {
    if (window.location.hash) {
      window.location.hash = '';
    }
    if (this.detElementId && this.isOnSubLayer) {
      const windowParent = window.parent.document.querySelector(".component-settings").querySelector(".formio-dialog-content > div > div");
      if (windowParent) {
        // const windowParent = window.parent.document.querySelector(".component-settings").querySelector(".formio-dialog-content > div > div");
        windowParent.querySelector(":scope > .row:nth-child(1)").classList.remove("d-none");
        // windowParent.querySelector(":scope > .row:nth-child(2)").classList.remove("d-none");
        windowParent.querySelector(":scope > .row:nth-child(2)").querySelector("#myBuilder").classList.remove("m-0");
        windowParent.querySelector(":scope > .row:nth-child(2)").querySelector(".tab-pane.active").classList.remove("p-0", "m-0");
        const copyValueFrom = windowParent.querySelector(":scope > .row:nth-child(2)").querySelector(".tab-pane.active").querySelector(".formio-component-copyValueFrom");
        if (copyValueFrom) {
          copyValueFrom.classList.remove("d-none");
        }
        // windowParent.querySelector(":scope > .row:last-child").classList.remove("d-none");
        window.parent.document.querySelector(".component-settings").querySelector(".formio-dialog-close").classList.remove("d-none");
        windowParent.querySelector("#element1")?.querySelector(":scope > .formio-component-tabs")?.querySelector(":scope > .nav-tabs")?.classList.remove("d-none");
      }
    }
    this.editCancel.emit({ cancel: true });
  }

  public createBooleanDeterminant(
    serviceId: string,
    determinant: BooleanDeterminant,
  ) {
    this.determinantService
      .createBooleanDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createNumericDeterminant(
    serviceId: string,
    determinant: NumericDeterminant,
  ) {
    this.determinantService
      .createNumericDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createMoneyDeterminant(
    serviceId: string,
    determinant: MoneyDeterminant,
  ) {
    this.determinantService
      .createMoneyDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createTextDeterminant(
    serviceId: string,
    determinant: TextDeterminant,
  ) {
    this.determinantService
      .createTextDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createFileDeterminant(
    serviceId: string,
    determinant: FileDeterminant,
  ) {
    this.determinantService
      .createFileDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createSelectDeterminant(
    serviceId: string,
    determinant: SelectDeterminant,
  ) {
    this.determinantService
      .createSelectDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createSelectBoxesDeterminant(
    serviceId: string,
    determinant: SelectBoxesDeterminant,
  ) {
    this.determinantService
      .createSelectBoxesDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }
  // SelectBoxesDeterminant
  public createRadioDeterminant(
    serviceId: string,
    determinant: RadioDeterminant,
  ) {
    this.determinantService
      .createRadioDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createClassificationDeterminant(
    serviceId: string,
    determinant: ClassificationDeterminant,
  ) {
    this.determinantService
      .createClassificationDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createSubCatalogDeterminant(
    serviceId: string,
    determinant: SubCatalogDeterminant,
  ) {
    this.determinantService
      .createSubCatalogDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createDateDeterminant(
    serviceId: string,
    determinant: DateDeterminant,
  ) {
    this.determinantService
      .createDateDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createGridDeterminant(
    serviceId: string,
    determinant: GridDeterminant,
  ) {
    this.determinantService
      .createGridDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createBotDeterminant(
    serviceId: string,
    determinant: BotDeterminant,
  ) {
    this.determinantService
      .createBotDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createRegistrationDeterminant(
    serviceId: string,
    determinant: RegistrationDeterminant,
  ) {
    this.determinantService
      .createRegistrationDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createCollectionPlaceDeterminant(
    serviceId: string,
    determinant: CollectionPlaceDeterminant,
  ) {
    this.determinantService
      .createCollectionPlaceDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveBooleanDeterminant(
    serviceId: string,
    determinant: BooleanDeterminant,
  ) {
    this.determinantService
      .saveBooleanDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  private addHandler(determinant: Determinant) {
    this.store.state.common.addDeterminantModal.closeModal(determinant);
    this.closeLayer();
    this.responseSuccessful("Determinant created!");
  }

  private saveHandler() {
    // this.closeLayer();
    this.cancel();
    this.responseSuccessful("Determinant saved!");
    this.store.state.common.editDeterminantModal.emitDeterminantHasChanged(
      this.determinant,
    );
  }

  public saveNumericDeterminant(
    serviceId: string,
    determinant: NumericDeterminant,
  ) {
    this.determinantService
      .saveNumericDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveMoneyDeterminant(
    serviceId: string,
    determinant: MoneyDeterminant,
  ) {
    this.determinantService
      .saveMoneyDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveTextDeterminant(serviceId: string, determinant: TextDeterminant) {
    this.determinantService
      .saveTextDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveFileDeterminant(serviceId: string, determinant: FileDeterminant) {
    this.determinantService
      .saveFileDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveGridDeterminant(serviceId: string, determinant: GridDeterminant) {
    this.determinantService
      .saveGridDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createButtonDeterminant(
    serviceId: string,
    determinant: ButtonDeterminant,
  ) {
    this.determinantService
      .createButtonDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveButtonDeterminant(
    serviceId: string,
    determinant: ButtonDeterminant,
  ) {
    this.determinantService
      .saveButtonDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createGridComponentDeterminant(
    serviceId: string,
    determinant: GridComponentDeterminant,
  ) {
    this.determinantService
      .createGridComponentDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveGridComponentDeterminant(
    serviceId: string,
    determinant: GridComponentDeterminant,
  ) {
    this.determinantService
      .saveGridComponentDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public createFileUploadDeterminant(
    serviceId: string,
    determinant: FileUploadDeterminant,
  ) {
    this.determinantService
      .createFileUploadDeterminant(serviceId, determinant)
      .subscribe(
        (data) => this.addHandler(data),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveFileUploadDeterminant(
    serviceId: string,
    determinant: FileUploadDeterminant,
  ) {
    this.determinantService
      .saveFileUploadDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveRadioDeterminant(
    serviceId: string,
    determinant: RadioDeterminant,
  ) {
    this.determinantService
      .saveRadioDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveSelectDeterminant(
    serviceId: string,
    determinant: SelectDeterminant,
  ) {
    this.determinantService
      .saveSelectDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveSelectBoxesDeterminant(
    serviceId: string,
    determinant: SelectBoxesDeterminant,
  ) {
    this.determinantService
      .saveSelectBoxesDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveClassificationDeterminant(
    serviceId: string,
    determinant: ClassificationDeterminant,
  ) {
    this.determinantService
      .saveClassificationDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveSubCatalogDeterminant(
    serviceId: string,
    determinant: SubCatalogDeterminant,
  ) {
    this.determinantService
      .saveSubCatalogDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveDateDeterminant(serviceId: string, determinant: DateDeterminant) {
    this.determinantService
      .saveDateDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveBotDeterminant(
    serviceId: string,
    determinant: BotDeterminant,
  ) {
    this.determinantService
      .saveBotDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveRegistrationDeterminant(
    serviceId: string,
    determinant: RegistrationDeterminant,
  ) {
    this.determinantService
      .saveRegistrationDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public saveCollectionPlaceDeterminant(
    serviceId: string,
    determinant: CollectionPlaceDeterminant,
  ) {
    this.determinantService
      .saveCollectionPlaceDeterminant(serviceId, determinant)
      .subscribe(
        () => this.saveHandler(),
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public generateAdditionalInfoText() {
    let text = "";
    if (this.determinant?.usages?.length) {
      text = "<div>" + this.translate("Determinant used in following places") + ":</div><ul>";
      this.determinant.usages.forEach((usage) => {
        text += "<li class='determinant-element-row p-2'><ul class='m-0'><li>" + this.translate("Type") + ": <b>" + usage.type + "</b></li><li>" +
          this.translate("Key") + ": <b>" + usage.entityId + "</b></li><li>" +
          this.translate("Name") + ": <b>" + usage.name + "</b></li></ul></li>";
      });
      text += "</ul>";
    }
    return text;
  }

  public deleteDeterminant() {
    this.determinantService
      .deleteDeterminant(this.serviceId, this.determinant.id)
      .subscribe(
        () => {
          this.determinant.deletedWhen = moment().toISOString();
          this.saveHandler();
        },
        (error) => { this.showErrorMessage(error); this.isLoading = false; },
        () => this.isLoading = false,
      );
  }

  public updateDeterminant(determinant: BotDeterminant) {
    this.determinant = determinant;
  }

  public closeLayer() {
    if (this.detElementId && this.isOnSubLayer) {
      const windowParent = window.parent.document.querySelector(".component-settings").querySelector(".formio-dialog-content > div > div");
      if (windowParent) {
        // const windowParent = window.parent.document.querySelector(".component-settings").querySelector(".formio-dialog-content > div > div");
        windowParent.querySelector(":scope > .row:nth-child(1)").classList.remove("d-none");
        // windowParent.querySelector(":scope > .row:nth-child(2)").classList.remove("d-none");
        windowParent.querySelector(":scope > .row:nth-child(2)").querySelector("#myBuilder").classList.remove("m-0");
        windowParent.querySelector(":scope > .row:nth-child(2)").querySelector(".tab-pane.active").classList.remove("p-0", "m-0");
        const copyValueFrom = windowParent.querySelector(":scope > .row:nth-child(2)").querySelector(".tab-pane.active").querySelector(".formio-component-copyValueFrom");
        if (copyValueFrom) {
          copyValueFrom.classList.remove("d-none");
        }
        // windowParent.querySelector(":scope > .row:last-child").classList.remove("d-none");
        window.parent.document.querySelector(".component-settings").querySelector(".formio-dialog-close").classList.remove("d-none");
        windowParent.querySelector("#element1").querySelector(":scope > .formio-component-tabs").querySelector(":scope > .nav-tabs").classList.remove("d-none");
      }
    }
    this.formSubmit.emit({
      reload: false,
      cancel: true,
    });
  }

  public compareEnum(anEnum: SelectOperatorType, aValue: string): boolean {
    return anEnum && anEnum.toString() === aValue;
  }

  public formatUsageType(type: string): string {
    switch (type) {
      case "FORM_FIELD":
      case "FIELD_FORMULA":
      case "FIELD_VALIDATION":
        return "primary";
      case "MAPPING":
      case "ACTION":
        return "secondary";
      case "ROLE":
      case "ROLE_INSTITUTION":
        return "info";
      case "REGISTRATION":
      case "COST":
      case "REQUIREMENT":
      case "RESULT":
        return "warning";
      case "OTHER":
        return "dark";
      default:
        return "light";
    }
  }

  /**
   * Finds all determinants that are duplicates of the given determinant.
   * Returns an array of duplicate determinants (excluding the input determinant).
   */
  private findDuplicateDeterminants(determinant: Determinant, excludeId?: string): Determinant[] {
    return this.existingDeterminants.filter((existing) => {
      // Skip the same determinant if excludeId is provided
      if (excludeId && existing.id === excludeId) {
        return false;
      }

      // Skip if determinantType doesn't match
      if (existing.determinantType !== determinant.determinantType) {
        return false;
      }

      // Type-aware duplicate detection based on determinantType
      switch (determinant.determinantType) {
        case "FORMFIELD":
          return this.isFormfieldDuplicate(existing, determinant);
        case "BOT":
          return this.isBotDuplicate(existing, determinant);
        case "EVENT":
          return this.isEventDuplicate(existing, determinant);
        case "REGISTRATION":
          return this.isRegistrationDuplicate(existing, determinant);
        case "COLLECTION_PLACE":
          return this.isCollectionPlaceDuplicate(existing, determinant);
        default:
          return false;
      }
    });
  }

  /**
   * Checks if a determinant is duplicated based on its type and relevant properties.
   * Duplicate detection is type-aware to ensure semantic equivalence.
   */
  private isDuplicateDeterminant(determinant: Determinant): boolean {
    if (!this.existingDeterminants || this.existingDeterminants.length === 0) {
      return false;
    }

    return this.existingDeterminants.some((existing) => {
      // Skip if determinantType doesn't match
      if (existing.determinantType !== determinant.determinantType) {
        return false;
      }

      // Type-aware duplicate detection based on determinantType
      switch (determinant.determinantType) {
        case "FORMFIELD":
          return this.isFormfieldDuplicate(existing, determinant);
        case "BOT":
          return this.isBotDuplicate(existing, determinant);
        case "EVENT":
          return this.isEventDuplicate(existing, determinant);
        case "REGISTRATION":
          return this.isRegistrationDuplicate(existing, determinant);
        case "COLLECTION_PLACE":
          return this.isCollectionPlaceDuplicate(existing, determinant);
        default:
          return false;
      }
    });
  }

  private isFormfieldDuplicate(existing: Determinant, determinant: Determinant): boolean {
    if (existing.targetFormFieldKey !== determinant.targetFormFieldKey) {
      return false;
    }

    if ((existing as any).operator !== (determinant as any).operator) {
      return false;
    }

    const valueProperties = [
      "value",
      "sourceFormFieldKey",
      "classificationField",
      "gdbCatalogSelectedValue",
      "gdbCatalogFieldId",
      "gdbCatalogValue",
      "operatorStringValue",
      "textValue",
      "numericValue",
      "moneyValue",
      "booleanValue",
      "dateValue",
      "isCurrentDate",
      "selectValue",
      "classificationFields",
      "classificationFieldIds",
      "classificationGroup",
      "parentCatalogField",
      "subCatalogField",
      "buttonEventName",
      "buttonKey",
      "fileUploadEventName",
      "fileUploadKey",
      "gridEventName",
      "gridKey",
      "operator",
      "textOperator",
      "selectOperator",
      "classificationOperator",
      "determinantInsideGrid",
    ];

    const valueMatch = valueProperties.every((property) => {
      return _.isEqual(existing[property], determinant[property]);
    });

    if (!valueMatch) {
      return false;
    }

    // Check subject only if not inside grid
    if (!(existing as any).determinantInsideGrid) {
      if (!_.isEqual(existing.subject, determinant.subject)) {
        return false;
      }
    }

    // Check rowDeterminant specifically if it exists
    const existingRowDet = (existing as any).rowDeterminant;
    const determinantRowDet = (determinant as any).rowDeterminant;

    if (existingRowDet || determinantRowDet) {
      if (!existingRowDet || !determinantRowDet) {
        return false;
      }

      const rowDeterminantProperties = [
        'operator', 'textOperator', 'selectOperator', 'classificationOperator',
        'numericValue', 'moneyValue', 'textValue', 'booleanValue', 'dateValue', 'isCurrentDate', 'selectValue',
        'classificationField', 'classificationFields', 'classificationFieldIds', 'classificationGroup',
        'parentCatalogField', 'subCatalogField',
        'sourceFormFieldKey', 'targetFormFieldKey'
      ];

      return rowDeterminantProperties.every(prop => {
        return _.isEqual(existingRowDet[prop], determinantRowDet[prop]);
      });
    }

    return true;
  }

  private isBotDuplicate(existing: Determinant, determinant: Determinant): boolean {
    const existingBots = existing.bots || [];
    const determinantBots = determinant.bots || [];

    if (existingBots.length !== determinantBots.length) {
      return false;
    }

    const existingBotIds = existingBots.map((b) => b.id || b).sort();
    const determinantBotIds = determinantBots.map((b) => b.id || b).sort();

    return existingBotIds.every((id, index) => id === determinantBotIds[index]);
  }

  private isEventDuplicate(existing: Determinant, determinant: Determinant): boolean {
    return (
      existing.eventName === determinant.eventName &&
      existing.eventComponent === determinant.eventComponent
    );
  }

  private isRegistrationDuplicate(existing: Determinant, determinant: Determinant): boolean {
    return existing.registrationId === determinant.registrationId;
  }

  private isCollectionPlaceDuplicate(existing: Determinant, determinant: Determinant): boolean {
    return existing.registrationLocationKey === determinant.registrationLocationKey;
  }
}
